export default __webpack_public_path__ + "static/media/waterMark.afb61b81.svg";